import { useCallback, useContext } from 'react';

import type { WalletIsLocked } from '@sorare/wallet-shared/';
import { MessagingContext } from '@sorare/wallet-shared/';

const useWalletIsLocked = () => {
  const { sendRequest } = useContext(MessagingContext)!;

  return useCallback(
    (isLocked: boolean) => {
      sendRequest<WalletIsLocked>('walletIsLocked', { isLocked });
    },
    [sendRequest]
  );
};

export default useWalletIsLocked;
